import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import img from '../../../../../assets/img/avatar4.jpg'
import { loadChats,getChatUsers, sendMessage } from "../../../../actions/chatsAction";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';

const MemberChat = (props) => {

    const dispatch = useDispatch();
    const { messages, users} = useSelector(state => state.chatStore);
    const { user } = useSelector(state => state.auth);
    // const [members, setMembers] = useState([])
    const [projectId, setProjectId] = useState()
    const [receiverId, setReceiverId] = useState()
    const [message, setMessage] = useState('')

    const validationSchema = yup.object().shape({
        receiverId: yup.string().required('Please Select the user'),
        message: yup.string().required('Please Enter the message'),
    });
    const { register, handleSubmit, setValue,formState: { errors } } = useForm({
        mode: "onBlur",
        resolver: yupResolver(validationSchema),
    });
    const onChatSubmit = async (values, e) => {
        const formData = { project_id: projectId, reciever_id: values.receiverId, message: values.message }
        dispatch(sendMessage(formData))
        setMessage('')
        setValue('message', '')
    }

    useEffect(() => {
        if (projectId) {
            dispatch(getChatUsers(projectId))
            dispatch(loadChats(projectId, receiverId))
        }
    }, [dispatch, projectId, receiverId])

    useEffect(() => {
        // setMembers(props?.members)
        setProjectId(props?.project?.id)
    }, [props, messages])


    return (
        <>
            <div className="row clearfix">

                <div className="card chat-app">
                    <div className="chat">
                        <div className="chat-header clearfix">
                            <div className="row clearfix">
                                <div className="col-lg-6">
                                    <div className="chat-about">
                                        <h6 className="m-b-0 text-left">#{props?.project?.title}</h6>
                                    </div>
                                </div>
                                <div className="col-lg-6 hidden-sm text-right">
                                </div>
                            </div>
                        </div>
                        <div className="chat-history">
                            <ul className="m-b-0 chat-scroll">
                                {messages && messages.map((message, index) => (

                                    <li key={index} className={message?.sender_user?.id === user.user_id ? "clearfix text-right px-3" : " clearfix text-left px-3"} >
                                        <div className="message-data ">
                                            <span className="message-data-time mr-2">{ moment(message.createdAt).fromNow() }</span>
                                            <img width={40} height={40} src={message?.sender_user?.id === user.user_id ? message?.sender_user.profile_pic_url : message?.reciever_user.profile_pic_url} alt="avatar" />
                                        </div>
                                        <div className="message my-message">{message.message}.</div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <form className="form-auth-small" onSubmit={handleSubmit(onChatSubmit)}>
                            <div className="chat-message clearfix">
                                <div className="col-md-4 col-lg-4 col-sm-12 mb-2">
                                    <div className="form-inline">
                                        <label className="pt-2">To: </label>
                                        <select {...register('receiverId')} onChange={(e) => setReceiverId(e.target.value)} className="form-control ml-2 custum-bg-warning text-white" style={{ borderRadius: '15px' }}>
                                            <option value={''}>Select Users</option>
                                            {users && users.map((user, index) => (
                                                <option key={index} value={user.id}>{user.name}</option>
                                            ))}
                                        </select>
                                        {errors.receiverId && (<div className="text-danger pl-5">{errors.receiverId.message}</div>)}
                                    </div>
                                </div>
                                <div className="input-group mb-0">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" onClick={handleSubmit(onChatSubmit)} ><i className="icon-paper-plane"></i></span>
                                    </div>
                                    <textarea
                                        type="text"
                                        onChange={(e) => setMessage(e.target.value)}
                                        defaultValue={message}
                                        {...register('message')}
                                        className="form-control p-2"
                                        onKeyPress={event => event.key === 'Enter' ? handleSubmit(onChatSubmit) : null}
                                        placeholder="Enter text here..." />
                                </div>
                                {errors.message && (<div className="text-danger text-left">{errors.message.message}</div>)}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MemberChat;